let copySource = {
    document: {
        title:'Comprar puntos/Puntos de regalo'
    },
    headerNav:{
        logo:{
            alt:'Marriott Bonvoy',
            link:'https://www.marriott.com/default.mi'
        },
        home: {
            copy: 'Home',
            link: ''
        },
        buy: {
            copy:'Comprar puntos',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=es-ES&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=es-ES&iscid=points_buy_cta_em_pr'
        },
        gift: {
            copy:'Regalar puntos',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=es-ES&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=es-ES&iscid=points_gift_cta_em_pr'
        },
        multiply: {
            copy:'Multiplica puntos',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=es-ES&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=es-ES&iscid=points_multiply_plp_web_ev'
        },
        mr: {
            copy:'Marriott.com',
            link:'https://www.espanol.marriott.com/default.mi'
        },
    },
    hero: {
        lang: 'landing-es',
        headline: {
            lineOne: "Puntos para cumplir tus deseos.",
            lineTwo: 'Compra ahora, ve cuando lo desees.',
        },
        subHeadline : 'Cuando llega la inspiración, tiene puntos para hacerla\n realidad. Ya sea que se trate de hacer un desvío encantador o\n de vivir una experiencia espontánea, hay innumerables\n lugares para visitar y actividades para realizar. Compra o\n regala puntos ahora mismo.',
        alt: 'Convierta sus puntos en viajes inolvidables. Reserve un viaje de su lista de deseos. Pase más noches fuera de la ciudad. Este es el año de ir por más, y todo es posible con puntos Marriott Bonvoy®.'
    },
    promo: {
        hero: {
            promoLang: 'promo-es',
            headline: "Wonders of More",
            body:"Get closer to your next vacation with a 50% bonus on purchases of 2,000 or more points October 6–13.",
        }
    },
    ctas:{
        buy:{
            imgAlt:'Ventana interior de habitación de hotel con vistas a un paisaje urbano.',
            header:'Comprar puntos',
            copy:'Desde agregar una noche adicional hasta obtener acceso VIP a un\n espectáculo agotado, compre puntos ahora para estar listo para\n cualquier cosa.',
            linkCopy:'COMPRAR PUNTOS',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=es-ES&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=es-ES&iscid=points_buy_cta_em_pr'
        },
        gift:{
            imgAlt:'Balcón del hotel con piscina con vistas al mar.',
            header:'Regalar puntos',
            copy:'Regale puntos a amigos y familiares para que puedan disfrutar\n cuando y donde deseen.',
            linkCopy:'Regalar puntos',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=es-ES&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=es-ES&iscid=points_gift_cta_em_pr'
        },
        multiply:{
            imgAlt:'Hotel balcony with a pool overlooking the ocean.',
            header:'Multiplica puntos',
            copy:'¿Acumulaste puntos con una estancia reciente? Ahora puedes comprar hasta cuatro veces más con un descuento para vivir más en grande en tu próximo viaje.',
            linkCopy:'COMPRA PUNTOS Y AHORRA',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=es-ES&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=es-ES&iscid=points_multiply_plp_web_ev'
        },
        membership:{
            imgAlt:'',
            imgSrc: './images/mr_rebrand_register_Placeholder.png',
            header: 'Hágase socio',
            link: 'https://www.marriott.com/es/loyalty/createAccount/createAccountPage1.mi?enrollmentSourceCode=MSPV',
            copy: 'Obtenga acceso a las tarifas para socios, puntos para noches gratuitas y mucho más.Los nuevos socios pueden comprar puntos treinta (30) días después de inscribirse en el programa Marriott Bonvoy.'
        }
    },
    footer:{
        copyrightOne:'Este sitio web es operado por Points.com Inc. en nombre de Marriott International, Inc. para la compra de Marriott Bonvoy Points de acuerdo con los ',
        copyrightLinkTC: 'https://points-ebgt.s3.amazonaws.com/marriott/terms-conditions/bonvoy-terms-and-conditions-ES-ES.html',
        copyrightTwo:'Términos y condiciones de Points.com Inc.',
        copyrightThree:'. La adjudicación y el uso de Marriott Bonvoy Points en relación con una transacción de compra están sujetos a las ',
        copyrightLinkTwo: 'https://www.marriott.com/loyalty/terms/default.mi',
        copyrightFour:'Normas',
        copyrightFive:' y a la ',
        copyrightLinkThree: 'https://www.marriott.com/about/privacy.mi',
        copyrightSix:'Política de privacidad del Programa Marriott Bonvoy',
        copyrightSeven:'.',

        options: {
            de: "Deutsch",
            es: "Español",
            en:'English',
            fr: 'Français',
            it: 'Italiano',
            jp:'日本語',
            pt:'Português',
            ch:'国际'
        },
        footerbar:{
            logo: "./images/bonvoy_logo.png",
            grp1: "LUXURY",
            grp2: "PREMIUM",
            grp3: "SELECT",
            grp4: "MIDSCALE",
            grp5: "LONGER STAYS"
        },
        langIconSrc: './images/Icon-Globe.svg',
        langIconAlt: 'Español',
        tracking:{
            doNotSell:{
                copy:'No quiero que se comercialicen mis datos personales',
                href:'https://www.marriott.com/about/ccpa/do-not-sell.mi'
            },
            prefs: {
                copy:'Preferencias de seguimiento',
                href:'https://consent-pref.trustarc.com/?layout=gdpr&type=marriottgdpr&site=marriottgdpr.com&action=notice&country=ca&locale=en&behavior=implied&irm=undefined&from=https://consent.trustarc.com/'
            }
        },
        terms:{
            copy:'Condiciones de uso',
            href:'https://www.espanol.marriott.com/about/terms-of-use.mi'
        },
        programTerms:{
            copy:'Términos y condiciones del programa',
            href:'https://www.espanol.marriott.com/loyalty/terms/default.mi'
        },
        privacy:{
            copy:'Centro de privacidad',
            href:'https://www.espanol.marriott.com/sobre-marriott/privacidad.mi'
        },
        accessibility:{
            copy:'Accesibilidad digital',
            href:'https://www.espanol.marriott.com/digital-accessibility.mi'
        },
        siteMap:{
            copy:'Mapa del sitio',
            href:'https://www.espanol.marriott.com/sitemap.mi'
        },
        help:{
            copy:'Ayuda',
            href:'https://www.espanol.marriott.com/help/default.mi'
        },
    }
    
}

export default copySource

